import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSubscriptionTick1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSubscriptionTick1"><Path d="M11.9981 2.5L14.5108 5.39189L18.2945 4.79168L18.3604 8.6221L21.6447 10.5944L19.233 13.5711L20.4811 17.193L16.7204 17.9231L15.3483 21.5L11.9981 19.6419L8.6479 21.5L7.27586 17.9231L3.51508 17.193L4.7632 13.5711L2.35156 10.5944L5.63584 8.6221L5.70178 4.79168L9.48546 5.39189L11.9981 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 12.75L11 14.25L14.5 10.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSubscriptionTick1;
